function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Faq Template Scripts
 *    Scripts that are only meant to run on the Faq Template.
 *
 *  Version:
 *    1.0.0 - 2020/03/16
 */

import { Accordion } from './../objects/content/Accordion';
import * as ResponsiveSizes from './../settings/Responsive';

// Selectors
export var FAQ_TEMPLATE_CONTAINER = '[data-faq-template]';
export var FAQ_CATEGORY_SELECTOR = '[data-faq-category]';
export var FAQ_CATEGORY_HANDLE = 'data-category-handle';
export var FAQ_ACCORDION_SELECTOR = '[data-faq-accordion]';
export var CATEGORIES_CAROUSEL_CONTAINER_SELECTOR = '[data-faq-categories-carousel-container]';
export var CATEGORIES_CAROUSEL_SELECTOR = '[data-faq-categories-carousel]';
export var ARTICLES_CAROUSEL_CONTAINER_SELECTOR = '[data-faq-articles-carousel-container]';
export var ARTICLES_CAROUSEL_SELECTOR = '[data-faq-articles-carousel]';
export var CLASS_INITIALIZED = 'slick-initialized';
export var CLASS_VISIBLE = 'is-visible';
var FaqTemplate = /*#__PURE__*/function () {
  function FaqTemplate(container) {
    var _this = this;
    _classCallCheck(this, FaqTemplate);
    // Elements
    this.container = container;
    this.faqAccordions = this.container.find(FAQ_ACCORDION_SELECTOR);
    this.categoriesCarouselContainer = container.find(CATEGORIES_CAROUSEL_CONTAINER_SELECTOR);
    this.categoriesCarousel = container.find(CATEGORIES_CAROUSEL_SELECTOR);
    this.articlesCarousels = container.find(ARTICLES_CAROUSEL_SELECTOR);

    // Initialise accordions
    this.faqAccordions.each(function (i, e) {
      new Accordion($(e));
    });

    // Initialise carousels
    this.categoriesSlick = this.initCategoriesCarousel();
    this.articlesCarousels.each(function (i, e) {
      var self = $(e);
      var carouselContainer = self.parents(ARTICLES_CAROUSEL_CONTAINER_SELECTOR);
      _this.initArticlesCarousel(self, carouselContainer);
    });

    // Set active accordion on slide change
    container.on('beforeChange', CATEGORIES_CAROUSEL_SELECTOR, function (e, slick, currentSlide, nextSlide) {
      _this.updateProgress(slick, currentSlide, nextSlide);
    });

    // Reinit slick based on window size
    $(window).on('resize orientationchange', function () {
      return _this.onResize();
    });

    // On desktop click, set active accordion
    container.on('click', FAQ_CATEGORY_SELECTOR, function (e) {
      return _this.setDesktopCategory(e);
    });
  }
  _createClass(FaqTemplate, [{
    key: "onResize",
    value: function onResize() {
      this.checkCategoriesCarousel();
      this.checkArticlesCarousel();
    }
  }, {
    key: "checkCategoriesCarousel",
    value: function checkCategoriesCarousel() {
      if (this.categoriesCarousel.hasClass(CLASS_INITIALIZED)) return;
      if ($(window).width() > ResponsiveSizes.medium - 1) return;
      this.initCategoriesCarousel(this.categoriesCarousel);
    }
  }, {
    key: "checkArticlesCarousel",
    value: function checkArticlesCarousel() {
      var _this2 = this;
      this.articlesCarousels.each(function (i, e) {
        if ($(window).width() > ResponsiveSizes.medium - 1) return;
        var self = $(e);
        if (self.hasClass(CLASS_INITIALIZED)) return;
        var carouselContainer = self.parents(ARTICLES_CAROUSEL_CONTAINER_SELECTOR);
        _this2.initArticlesCarousel(self, carouselContainer);
      });
    }
  }, {
    key: "initCategoriesCarousel",
    value: function initCategoriesCarousel() {
      var slick = this.categoriesCarousel.slick({
        mobileFirst: true,
        swipeToSlide: true,
        cssEase: this.categoriesCarouselContainer.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
        touchThreshold: 200,
        infinite: this.categoriesCarouselContainer.data('infinite') === true ? true : false,
        autoplay: this.categoriesCarouselContainer.data('autoplay') == true,
        autoplaySpeed: this.categoriesCarouselContainer.data('autoplay-speed') * 1000 || 5000,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        responsive: [{
          breakpoint: ResponsiveSizes.small - 1,
          settings: {
            slidesToShow: 4
          }
        }, {
          breakpoint: ResponsiveSizes.medium - 1,
          settings: "unslick"
        }]
      });
      return slick;
    }
  }, {
    key: "initArticlesCarousel",
    value: function initArticlesCarousel(carouselElement, carouselContainer) {
      var slick = carouselElement.slick({
        mobileFirst: true,
        swipeToSlide: true,
        cssEase: carouselContainer.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
        touchThreshold: 200,
        infinite: carouselContainer.data('infinite') === true ? true : false,
        autoplay: carouselContainer.data('autoplay') == true,
        autoplaySpeed: carouselContainer.data('autoplay-speed') * 1000 || 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        responsive: [{
          breakpoint: ResponsiveSizes.small - 1,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: ResponsiveSizes.medium - 1,
          settings: "unslick"
        }]
      });
      return slick;
    }
  }, {
    key: "updateProgress",
    value: function updateProgress(slick, currentSlide, nextSlide) {
      var slideEl = this.container.find("[data-slick-index=\"".concat(nextSlide, "\"] ").concat(FAQ_CATEGORY_SELECTOR));
      var categoryHandle = slideEl.attr('data-category-handle');

      // Set active accordion
      this.setRelatedActive(categoryHandle);
    }
  }, {
    key: "setDesktopCategory",
    value: function setDesktopCategory(e) {
      if (!$(window).width() > ResponsiveSizes.medium - 1) return;
      var self = $(e.currentTarget);
      var categoryHandle = self.attr(FAQ_CATEGORY_HANDLE);

      // Remove current active class
      this.container.find(FAQ_CATEGORY_SELECTOR).removeClass('is-active');

      // Set new active category
      self.addClass('is-active');

      // Set active accordion
      this.setRelatedActive(categoryHandle);
    }
  }, {
    key: "setRelatedActive",
    value: function setRelatedActive(categoryHandle) {
      // Return if we don't have the category handle
      if (!categoryHandle) return;
      this.container.find(FAQ_ACCORDION_SELECTOR).removeClass(CLASS_VISIBLE);
      this.container.find("[data-faq-accordion=\"".concat(categoryHandle, "\"]")).addClass(CLASS_VISIBLE);
      this.container.find(ARTICLES_CAROUSEL_CONTAINER_SELECTOR).removeClass(CLASS_VISIBLE);
      this.container.find("[data-faq-articles=\"".concat(categoryHandle, "\"]")).addClass(CLASS_VISIBLE);
      this.container.find("[data-faq-articles=\"".concat(categoryHandle, "\"] ").concat(ARTICLES_CAROUSEL_SELECTOR)).slick('resize');
      this.container.find("[data-faq-articles=\"".concat(categoryHandle, "\"] ").concat(ARTICLES_CAROUSEL_SELECTOR)).addClass(CLASS_VISIBLE);
    }
  }]);
  return FaqTemplate;
}();
$(document).ready($(FAQ_TEMPLATE_CONTAINER).each(function (i, e) {
  return new FaqTemplate($(e));
}));